// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_my-0";
export var buttonContainer = "_my-3";
export var cancelButton = "_my-4";
export var headerSection = "_my-6";
export var headerTitle = "_my-9";
export var messageSideLeft = "_my-1";
export var messageSideRight = "_my-2";
export var orderNumberContainer = "_my-7";
export var orderNumberLabel = "_my-8";
export var submitButton = "_my-5";